var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('BorderSetting',{ref:"form",attrs:{"config":_vm.config,"predefine-theme-colors":_vm.predefineThemeColors}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }